module.exports = __webpack_public_path__ + "static/media/workout.de448357.svg";